import axiosAPI from 'axios';

const isTestingMode = true;
const isUATTestingMode = true;
const localEndpoint = 'http://192.168.1.18:8000/api/v6/';
const uatEndpoint = 'https://devapi.99gift.in/api/v6/';
const prodEndpoint = process.env.REACT_APP_99GIFT_ENDPOINT || 'https://api2.99gift.in/api/v6/';

const axios = axiosAPI.create({
  baseURL: isUATTestingMode ? uatEndpoint : isTestingMode ? localEndpoint : prodEndpoint,
});

export { axios };
